// TODO this whole concept needs to be reimagined

export default {

    data(){

        return {

            baseIcon : 'fa-cloud-upload'
        }
    },
    computed: {

        iconClasses(){

            const base = [ 'fa mr-2' ];
        
            if( this.isLoading ) base.push([ 'fa-spinner fa-spin' ]);
            else if( this.isDisabled ) base.push( 'fa-ban' );
            else base.push( this.baseIcon );
        
            return base.join( ' ' );
        },
    },
    methods: {

    }
}